import { render, staticRenderFns } from "./ProfessionDialog.vue?vue&type=template&id=129c86c9"
import script from "./ProfessionDialog.vue?vue&type=script&lang=js"
export * from "./ProfessionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports